import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Hidden from '@material-ui/core/Hidden';
import Divider from '@material-ui/core/Divider';
import Paper from '@material-ui/core/Paper';

import { DEFAULT_PAPER_ELEVATION, } from 'common/constants';
import SummarySellerTilesHeader from './SellerTilesHeader';

type Props = {
    renderHeader: Function | string,
};

const SummarySellerTiles: React.FC<Props> = ({
    children,
    renderHeader,
}) => {
    const header = typeof renderHeader === 'string'
        ? (<Typography variant="h5">{renderHeader}</Typography>)
        : renderHeader();

    return (
        <Box mb={2}>
            <Paper elevation={DEFAULT_PAPER_ELEVATION}
                           square>
                <Box px={{ xs: 0, md: 4, }}
                     py={{ xs: 0, md: 2, }}
                     display="flex"
                     flexDirection={{ xs: 'column', md: 'row', }}>
                    <Box flexBasis="20%"
                         component={SummarySellerTilesHeader}>
                        {header}
                    </Box>
                    <Hidden smDown>
                        <Box display="flex"
                             mr={3}>
                            <Divider orientation="vertical"/>
                        </Box>
                    </Hidden>
                    <Box p={{ xs: 2, md: 0, }}
                         width="100%">
                        {children}
                    </Box>
                </Box>
            </Paper>
        </Box>
    );
};

export default SummarySellerTiles;